import api from '@/api';

export default {
    /**
     *  문서 리스트를 가져옵니다	         
     */
    getForm(req: workflow.RequestForm): Promise<workflow.CM_Form> {
        return api.post<workflow.CM_Form>({
            url: '/workflow/form/api/get',
            data: req,
        }).then((res) => {
            return res;
        });
    },

    /**
     * 폼 액션을 수행합니다
     * @param req 
     * @returns 
     */
    actionForm(req: workflow.RequestActionForm): Promise<workflow.CM_Form> {
        return api.post<workflow.CM_Form>({
            url: '/workflow/form/api/action',
            data: req,
        }).then((res) => {
            return res;
        })
    },

    /**
     * 해당 문서의 회람자 목록을 조회합니다.
     * @param req 
     * @returns 
     */
     getLineHistory(req: workflow.TA_APPROVALLINE): Promise<Array<workflow.TA_APPROVALLINE>>{
        return api.post<Array<workflow.TA_APPROVALLINE>>({
            url: '/workflow/form/api/getHistory',
            data: req,
        }).then((res) => res);
    },
}